import { Component, Prop } from 'vue-property-decorator'
import Footer from '@/components/footer/footer'
import BasePage from '@/views/BasePage/BasePage'
import Payment from '@/components/payment/payment'
import AddCreditCard from '@/components/modalCreditCard/modalCreditCard'
import { Action, Getter, Mutation } from 'vuex-class'
import Header from '@/components/header/header'
import ModalCreditCard from '@/components/modalCreditCard/modalCreditCard'

@Component({
  components: {
    Payment,
    AddCreditCard,
    Footer,
    Header,
    ModalCreditCard
  }
})
export default class PaymentMethods extends BasePage {
  @Getter getUser: any
  @Getter getUniversity: any
  @Getter getCreditCards: any
  @Getter getCurrentPaymentMethod;

  @Mutation CURRENT_PAYMENT_METHOD;

  creditCardId = null
  isCreditCard = false
  showModalCC = false;

  mounted () {
    this.showModalCC = false;
    if(!this.getCurrentPaymentMethod) {
      this.CURRENT_PAYMENT_METHOD({
        card: null,
        type: 'cash',
        value: 'default'
      });
    }
  }

  _onChangePayment (val: any) {
    this.CURRENT_PAYMENT_METHOD(val);
  }

  _toggleModalCreditCard() {
    this.showModalCC = !this.showModalCC;
  }

}
